export const CONSENT_COOKIE_KEY = 'Rutab.CookieConsent';
export const CONSENT_COOKIE_GOOGLE_ANALYTICS = 'Google-Analytics';
export const CONSENT_COOKIE_NECESSARY = 'Necessary';